import './styles/app.scss';
import { WidthContextProvider } from './WidthContext';
import Footer from './components/common-footer/Footer';
import Header from './components/common-header/Header';
import Hero from './components/Hero/Hero';
import Intro from './components/Intro/Intro';
import Chapters from './components/Chapters/Chapters';

function App() {
  return (
    <WidthContextProvider>
      <main className="App">
        <Header clientName={'Regeneron'} />
        <Hero />
        <Intro />
        <Chapters />
        <Footer />
      </main>
    </WidthContextProvider>
  );
}

export default App;
